import { PipBaseStateComponent } from '../pip-base-state.component';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './virginia.model';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  PersonalInjuryProtectionSelection,
  CoverageLimit,
} from '../../../config/pip-constants';
import { TruncateModule } from 'axis-components/truncate';
@Component({
  selector: 'app-virginia',
  templateUrl: './virginia.component.html',
  styleUrls: ['./virginia.component.scss'],
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    CommonModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    TruncateModule,
    TooltipModule,
  ],
})
export class VirginiaComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('virginia', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('virginia', null);
    }
  }
  override dynamicRuleQueryBuilder(): string {
    if (
      this.baseRulesService.personalInjuryProtectionSelection ===
        PersonalInjuryProtectionSelection.IndividualStateCoverage ||
      (this.baseRulesService.personalInjuryProtectionSelection ===
        PersonalInjuryProtectionSelection.AcceptCoverage &&
        this.baseRulesService.coverageLimit === CoverageLimit.VaryByState)
    ) {
      return 'ShowAllOptions';
    }
  }

  // Override eventHook to clear error messages when first radio is selected
  override eventHook(value: any): void {
    // Check if the first main radio option is selected
    if (value === this.controls[0].option[0].select) {
      // Reset validation and clear error messages for the second and third radio groups
      if (this.reactiveForm && this.controls?.length >= 3) {
        // Reset the second radio group (controls[1])
        const radioGroup1 = this.reactiveForm.get(
          this.controls[1].formControlName,
        );
        if (radioGroup1) {
          radioGroup1.setValue(null);
          radioGroup1.markAsUntouched();
        }

        // Reset the third radio group (controls[2])
        const radioGroup2 = this.reactiveForm.get(
          this.controls[2].formControlName,
        );
        if (radioGroup2) {
          radioGroup2.setValue(null);
          radioGroup2.markAsUntouched();
        }

        // Also reset any dropdowns if they exist
        if (this.controls.length > 3) {
          const dropdown1 = this.reactiveForm.get(
            this.controls[3]?.formControlName,
          );
          if (dropdown1) {
            dropdown1.setValue(null);
            dropdown1.markAsUntouched();
          }

          const dropdown2 = this.reactiveForm.get(
            this.controls[4]?.formControlName,
          );
          if (dropdown2) {
            dropdown2.setValue(null);
            dropdown2.markAsUntouched();
          }
        }
      }
    }
  }

  override setupHookForDropDownData(): void {
    if (this.baseRules['selectionId'] === 'ShowMinOptions') {
      this.reactiveForm
        .get('levelTwoMedical_Radio')
        .setValue('Select_medicalExpenseBenefits_Radio');
      this.reactiveForm.get('levelTwoMedical_Radio').updateValueAndValidity();
    }
  }
}
